import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link'

import config from './lib/appsync-config'

const subscriptionsMiddleware = (resultsFetcher) =>
  createSubscriptionHandshakeLink(config, resultsFetcher)

export default subscriptionsMiddleware
